var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifiIconPlain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.20007 13.4C6.01919 13.4 9.68189 14.9171 12.3824 17.6176C15.0829 20.3181 16.6001 23.9808 16.6001 27.8M2.20007 2.19995C8.98962 2.19995 15.5011 4.89709 20.302 9.69802C25.1029 14.4989 27.8001 21.0104 27.8001 27.8M5.40007 26.2C5.40007 27.0836 4.68373 27.8 3.80007 27.8C2.91642 27.8 2.20007 27.0836 2.20007 26.2C2.20007 25.3163 2.91642 24.6 3.80007 24.6C4.68373 24.6 5.40007 25.3163 5.40007 26.2Z",
    stroke: "#F7F7F7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiIconPlain);
export default __webpack_public_path__ + "static/media/Wifi-Icon-Plain.a2337b00f9d02c24bc7f3ec482718b44.svg";
export { ForwardRef as ReactComponent };